"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockWogLogin = exports.SaveUserRole = exports.SaveScope = exports.SaveRole = exports.SaveApplication = exports.GetUserRole = exports.GetScope = exports.GetRole = exports.GetApplication = void 0;
const getApplicationDomain = __importStar(require("./get-application/get-application-domain"));
const getApplicationTransformer = __importStar(require("./get-application/transformer/get-application-domain-transformer"));
const getRoleDomain = __importStar(require("./get-role/get-role-domain"));
const getRoleTransformer = __importStar(require("./get-role/transformer/get-role-domain-transformer"));
const getScopeDomain = __importStar(require("./get-scope/get-scope-domain"));
const getScopeTransformer = __importStar(require("./get-scope/transformer/get-scope-domain-transformer"));
const getUserRoleDomain = __importStar(require("./get-user-role/get-user-role-domain"));
const getUserRoleTransformer = __importStar(require("./get-user-role/transformer/get-user-role-domain-transformer"));
const saveApplicationDomain = __importStar(require("./save-application/save-application-domain"));
const saveApplicationTransformer = __importStar(require("./save-application/transformer/save-application-domain-transformer"));
const saveRoleDomain = __importStar(require("./save-role/save-role-domain"));
const saveRoleTransformer = __importStar(require("./save-role/transformer/save-role-domain-transformer"));
const saveScopeDomain = __importStar(require("./save-scope/save-scope-domain"));
const saveScopeTransformer = __importStar(require("./save-scope/transformer/save-scope-domain-transformer"));
const saveUserRoleDomain = __importStar(require("./save-user-role/save-user-role-domain"));
const saveUserRoleTransformer = __importStar(require("./save-user-role/transformer/save-user-role-domain-transformer"));
const mockWogLoginDomain = __importStar(require("./mock-wog-login/mock-wog-login-domain"));
// =============================================================================
// Re-export
// =============================================================================
var GetApplication;
(function (GetApplication) {
    GetApplication.method = "GET";
    GetApplication.route = "auth-forwarder/api/auth-roles/applications";
    GetApplication.Domain = getApplicationDomain;
    GetApplication.Transformers = getApplicationTransformer;
})(GetApplication || (exports.GetApplication = GetApplication = {}));
var GetRole;
(function (GetRole) {
    GetRole.method = "GET";
    GetRole.route = (appId) => `auth-forwarder/api/auth-roles/applications/${appId}/roles`;
    GetRole.Domain = getRoleDomain;
    GetRole.Transformers = getRoleTransformer;
})(GetRole || (exports.GetRole = GetRole = {}));
var GetScope;
(function (GetScope) {
    GetScope.method = "GET";
    GetScope.route = (appId) => `auth-forwarder/api/auth-roles/applications/${appId}/scopes`;
    GetScope.Domain = getScopeDomain;
    GetScope.Transformers = getScopeTransformer;
})(GetScope || (exports.GetScope = GetScope = {}));
var GetUserRole;
(function (GetUserRole) {
    GetUserRole.method = "GET";
    GetUserRole.route = "auth-forwarder/api/auth-roles/user-roles";
    GetUserRole.Domain = getUserRoleDomain;
    GetUserRole.Transformers = getUserRoleTransformer;
})(GetUserRole || (exports.GetUserRole = GetUserRole = {}));
var SaveApplication;
(function (SaveApplication) {
    SaveApplication.method = "POST";
    SaveApplication.route = "auth-forwarder/api/auth-roles/applications";
    SaveApplication.Domain = saveApplicationDomain;
    SaveApplication.Transformers = saveApplicationTransformer;
})(SaveApplication || (exports.SaveApplication = SaveApplication = {}));
var SaveRole;
(function (SaveRole) {
    SaveRole.method = "POST";
    SaveRole.route = (appId) => `auth-forwarder/api/auth-roles/applications/${appId}/roles`;
    SaveRole.Domain = saveRoleDomain;
    SaveRole.Transformers = saveRoleTransformer;
})(SaveRole || (exports.SaveRole = SaveRole = {}));
var SaveScope;
(function (SaveScope) {
    SaveScope.method = "POST";
    SaveScope.route = (appId) => `auth-forwarder/api/auth-roles/applications/${appId}/scopes`;
    SaveScope.Domain = saveScopeDomain;
    SaveScope.Transformers = saveScopeTransformer;
})(SaveScope || (exports.SaveScope = SaveScope = {}));
var SaveUserRole;
(function (SaveUserRole) {
    SaveUserRole.method = "POST";
    SaveUserRole.route = "auth-forwarder/api/auth-roles/user-roles";
    SaveUserRole.Domain = saveUserRoleDomain;
    SaveUserRole.Transformers = saveUserRoleTransformer;
})(SaveUserRole || (exports.SaveUserRole = SaveUserRole = {}));
var MockWogLogin;
(function (MockWogLogin) {
    MockWogLogin.method = "POST";
    MockWogLogin.route = "auth-forwarder/api/auth-wog-user-mock/mock-login/resume";
    MockWogLogin.Domain = mockWogLoginDomain;
})(MockWogLogin || (exports.MockWogLogin = MockWogLogin = {}));
//# sourceMappingURL=index.js.map